var __jsx = React.createElement;
import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../styles/compare/OfferDetails.module.scss';
import * as gtag from '../../cookie/lib/gtag';

var LoanDetails = function LoanDetails(props) {
  var show = props.show,
      handleClose = props.handleClose,
      details = props.details,
      currency = props.currency,
      applyParams = props.applyParams,
      type = props.type;
  var provider = details.showLogo ? __jsx(Image, {
    src: details.providerLogo,
    height: details.logoSize.height,
    width: details.logoSize.width
  }) : __jsx("p", null, details.provider);
  var apr = details.interestScheme == 'dobanda_unica' ? __jsx(React.Fragment, null, Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.apr), "%") : __jsx("span", null, "\xEEntre ", Intl.NumberFormat('fr', {
    maximumFractionDigits: 2
  }).format(details.apr), " - ", details.aprMax);
  var totalCost = details.interestScheme == 'dobanda_unica' ? __jsx(React.Fragment, null, Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.totalAmount), " ", currency) : __jsx("span", null, "\xEEntre ", Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.totalAmount), " - ", Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.totalAmountMax), " ", currency);
  var installment = details.interestScheme == 'dobanda_unica' ? __jsx(React.Fragment, null, Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.monthlyPayment), " ", currency) : __jsx("span", null, "\xEEntre ", Intl.NumberFormat('fr', {
    maximumFractionDigits: 0
  }).format(details.monthlyPayment), " - ", details.monthlyPaymentMax, " ", currency);
  var interestRate, margin;

  if (details.interestScheme == 'dobanda_unica') {
    interestRate = __jsx("span", null, details.minInterestRate);

    if (details.rateType !== 'fixa') {
      margin = __jsx("span", null, details.referenceRate, " + ", details.minMargin);
    }
  } else {
    interestRate = __jsx("span", null, "intre ", details.minInterestRate, " si ", details.maxInterestRate);

    if (details.rateType !== 'fixa') {
      margin = __jsx("span", null, details.referenceRate, " + ", details.minMargin, " / ", details.maxMargin);
    }
  }

  var rate = details.interestScheme == 'dobanda_unica' ? details.monthlyPayment : __jsx("span", null, "\xEEntre ", details.monthlyPayment, " - ", details.monthlyPaymentMax);

  var riskFee = details.hasOwnProperty('riskFee') && __jsx(React.Fragment, null, __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision de risc"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.riskFee));

  var guaranteeFee = details.hasOwnProperty('stateGuarantee') && __jsx(React.Fragment, null, __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision de garantare"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.stateGuarantee));

  var relOpennerTag;

  if (details.hasOwnProperty('apply')) {
    relOpennerTag = details.apply.indexOf(" ".concat(process.env.NEXT_PUBLIC_SITE_URL, " ")) > -1 ? '' : 'noopener';
  } else if (details.hasOwnProperty('webLink')) {
    relOpennerTag = details.webLink.indexOf(" ".concat(process.env.NEXT_PUBLIC_SITE_URL, " ")) > -1 ? '' : 'noopener';
  }

  {
    relOpennerTag = '';
  }

  var onApply = function onApply() {
    if (window.location.hostname.indexOf('conso.ro') > 1) {
      gtag.event('Apply', {
        provider: details.provider,
        product: type
      });
    } else {
      console.log("beta");
    }

    handleClose();
  };

  return __jsx(Modal, {
    show: show,
    onHide: handleClose,
    dialogClassName: styles.modal90w
  }, __jsx(Modal.Header, {
    closeButton: true
  }, __jsx(Modal.Title, null, provider, __jsx("p", {
    className: "".concat(styles.productName, " text-muted mb-0")
  }, details.product))), __jsx(Modal.Body, null, details.hasOwnProperty('apply') && __jsx(Link, {
    href: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? "".concat(details.apply).concat(applyParams ? '?' + applyParams : '') : details.apply
  }, __jsx("a", {
    onClick: onApply,
    rel: relOpennerTag,
    target: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? '_self' : '_blank',
    title: "Solicit\u0103 oferta",
    className: "btn btn-primary mt-2 mb-3"
  }, "Solicit\u0103 oferta", __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  }))), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Cost total"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "DAE"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, apr), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Suma de rambursat"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, totalCost), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Prima rat\u0103 lunar\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, installment), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Costuri la acordarea creditului"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.upfrontFees)), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Dob\xE2nda"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Rata dob\xE2nzii"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, interestRate), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Tip dob\xE2nd\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.rateType), margin && __jsx(React.Fragment, null, __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Formula de calcul"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, margin)), details.specialTerms && __jsx(React.Fragment, null, __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Condi\u021Bii speciale"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.specialTerms))), __jsx(Row, {
    className: styles.endSection
  }, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Comisioane"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision de analiz\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.applicationFee), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision de administrare"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.managementFee), riskFee, guaranteeFee, __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Rambursare anticipat\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.earlyRepaymentFee), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Comision unic"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.uniqueFee)), __jsx(Row, null, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Asigur\u0103ri"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Asigurare de via\u021B\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.lifeInsurance ? details.lifeInsurance : '-'), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Asigurare de imobil"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.houseInsurance ? details.houseInsurance : '-'), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Alte asigur\u0103ri obligatorii"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.otherInsurance ? details.otherInsurance : '-')), __jsx(Row, null, __jsx(Col, {
    xs: "12",
    className: styles.productSection
  }, "Alte condi\u021Bii"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Venit minim (estimari Conso)"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.requiredIncome, " RON"), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Virare venit la banc\u0103"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.widthIncome ? 'da' : 'nu'), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Avans minim"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.minDownpayment), __jsx(Col, {
    xs: "12",
    md: "5",
    className: styles.key
  }, "Perioada de gra\u021Bie"), __jsx(Col, {
    xs: "12",
    md: "7",
    className: styles.info
  }, details.gracePeriod))), __jsx(Modal.Footer, {
    className: "justify-content-between"
  }, details.hasOwnProperty('apply') && __jsx(Link, {
    href: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? "".concat(details.apply).concat(applyParams ? '?' + applyParams : '') : details.apply
  }, __jsx("a", {
    onClick: onApply,
    rel: relOpennerTag,
    target: details.apply.indexOf("".concat(process.env.NEXT_PUBLIC_SITE_URL)) > -1 ? '_self' : '_blank',
    title: "Solicit\u0103 oferta",
    className: "btn btn-primary mt-2 mb-3"
  }, "Solicit\u0103 oferta", __jsx(FontAwesomeIcon, {
    className: "ml-2",
    icon: faChevronRight,
    height: "16",
    width: "16"
  }))), __jsx(Button, {
    variant: "outline-secondary",
    onClick: handleClose
  }, "\xCEnchide")));
};

export default LoanDetails;